import React from "react";
import { useOutletContext } from "react-router-dom";
import DashboardHeader from "../components/Other/DashboardHeader";
import Profile from "../components/Other/Profile";

const ProfilePage = () => {
  const [sidebarToggle] = useOutletContext();

  return (
    <>
      <DashboardHeader toggle={sidebarToggle} />
      <Profile />
    </>
  );
};

export default ProfilePage;